import { useState } from 'react';
import { Modal, Select, Button, message } from 'antd';
import LoaderComponent from '../../../Loader';
import API from '../../../../services/API';

const UpdateModeModal = ({ userId, accountId, refreshList, buttonProps = {} }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpendMode, setSelectedSpendMode] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  const updateSpendMode = async () => {
    if (!selectedSpendMode) return;
    try {
      setModalLoading(true);
      await API.spendMode(userId, selectedSpendMode, accountId);
      message.success(`Successfully changed the Spend Mode to ${selectedSpendMode}`);
      setModalOpen(false);
      refreshList();
    } catch (e) {
      message.error('Unable to change Spend Mode.');
      console.error('Unable to change Spend Mode.', e)
    } finally {
      setModalLoading(false);
      setSelectedSpendMode(null);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedSpendMode(null);
  };

  return (
    <>
      <Button
        type="primary"
        className="card-bottom-buttons"
        onClick={() => setModalOpen(true)}
        {...buttonProps}
      >
        Change Spend Mode
      </Button>
      
      <Modal
        title="Change Spend Mode"
        centered
        mask={true}
        maskClosable={true}
        okText="Update"
        destroyOnClose={true}
        okButtonProps={{disabled: !selectedSpendMode}}
        closable={true}
        open={modalOpen}
        onOk={updateSpendMode}
        onCancel={handleCancel}
        className="confirm-modal"
        
      >
        <p>Please select the new Spend Mode.</p>
        {!modalLoading &&
          <Select
            placeholder="Select Spend Mode"
            onSelect={(value) => setSelectedSpendMode(value)}
            style={{ minWidth: 200 }}
          >
            <Select.Option value="TRANSACTION_LIMIT">Transaction Limit</Select.Option>
            <Select.Option value="SPEND_LIMIT">Spend Limit</Select.Option>
          </Select>
        }
        {modalLoading && <LoaderComponent tip="Changing Spend Mode" />}
      </Modal>
    </>
  );
};

export default UpdateModeModal;